import { useTranslation } from 'react-i18next';
import { Grid } from '@shared/ui';

import { SectionHeader } from './SectionHeader';
import { AccordionShowcase } from './data-display/AccordionShowcase';
import { AdminKpiCardShowcase } from './data-display/AdminKpiCardShowcase';
import { AvatarShowcase } from './data-display/AvatarShowcase';
import { ChartBlockShowcase } from './data-display/ChartBlockShowcase';
import { DashboardCardRowShowcase } from './data-display/DashboardCardRowShowcase';
import { DescriptionListShowcase } from './data-display/DescriptionListShowcase';
import { AchievementsShowcase } from './data-display/AchievementsShowcase';
import { KpiCardShowcase } from './data-display/KpiCardShowcase';
import { TableShowcase } from './data-display/TableShowcase';
import { WeeklyReportCardShowcase } from './data-display/WeeklyReportCardShowcase';

export function DataDisplaySection() {
  const { t } = useTranslation();

  return (
    <section id="data-display" className="space-y-6">
      <SectionHeader
        title={t('uiLibrary.dataDisplay.title')}
        description={t('uiLibrary.dataDisplay.description')}
      />

      <Grid cols={1} gap="lg" className="lg:grid-cols-2">
        <div className="lg:col-span-2">
          <TableShowcase />
        </div>
        <div className="lg:col-span-2">
          <AdminKpiCardShowcase />
        </div>
        <div className="lg:col-span-2">
          <DashboardCardRowShowcase />
        </div>
        <div className="lg:col-span-2">
          <ChartBlockShowcase />
        </div>
        <div className="lg:col-span-2">
          <KpiCardShowcase />
        </div>
        <div className="lg:col-span-2">
          <WeeklyReportCardShowcase />
        </div>
        <div className="lg:col-span-2">
          <AchievementsShowcase />
        </div>
        <AvatarShowcase />
        <DescriptionListShowcase />
        <AccordionShowcase />
      </Grid>
    </section>
  );
}
